import * as queryString from "query-string";
import { getDollarValue } from "../helpers/currency";
import { FrontendRoutes, getFormLink, getTicketingLink } from "../routes/routes";
const thresholdPercentage = [105, 115, 130, 150];
const calculateMagicalAmounts = (lastAmountPaid) => {
    const amountsRoundsToFive = thresholdPercentage.map((threshold) => {
        return roundToFiveOrZero((threshold * lastAmountPaid) / 100);
    });
    return amountsRoundsToFive.reduce((calculatedAmounts, current) => {
        const prev = calculatedAmounts[calculatedAmounts.length - 1];
        if (current - prev < 5) {
            return [...calculatedAmounts, prev + 5];
        }
        if (current < 5) {
            return [...calculatedAmounts, 5];
        }
        return [...calculatedAmounts, current];
    }, []);
};
const roundToFiveOrZero = (value) => {
    const restToFive = value % 5;
    if (restToFive > 2.5) {
        return Math.round(value + (5 - restToFive));
    }
    else {
        return Math.round(value - restToFive);
    }
};
export const getUserQueryParams = (user, amount) => {
    const punctualAmounts = amount && calculateMagicalAmounts(getDollarValue(amount));
    return {
        firstName: user.firstName,
        lastName: user.lastName,
        email: user.email,
        address: user?.address,
        city: user?.city,
        postalCode: user?.postalCode,
        state: user?.region, // Use state instead of region cause &reg is interpreted as ® in html
        country: user?.country,
        amount: amount ? getDollarValue(amount) : undefined,
        punctualAmounts: punctualAmounts
            ? `[${punctualAmounts[0]}, ${punctualAmounts[1]}, ${punctualAmounts[2]}, ${punctualAmounts[3]}]`
            : "[]",
    };
};
export const generateMagicalLink = (frontendUrl, user, magicalLinkPath, amount) => {
    const queryParams = getUserQueryParams(user, amount);
    return `${frontendUrl}/${user.locale.toLowerCase()}${magicalLinkPath}?${queryString.stringify(queryParams)}`;
};
export const getTicketingMagicalLink = (frontendUrl, user, path) => {
    return generateMagicalLink(frontendUrl, user, `${FrontendRoutes.TicketingPage}${path}`);
};
export const getMembershipRenewalLink = ({ frontendUrl, ticketingPath, isoLocale, user, rateId, }) => {
    const params = {
        firstName: user.firstName,
        lastName: user.lastName,
        email: user.email,
        address: user.address,
        city: user.city,
        postalCode: user.postalCode,
        state: user.region,
        country: user.country,
        rateId,
    };
    const queryParams = new URLSearchParams();
    Object.entries(params).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== "") {
            queryParams.set(key, String(value));
        }
    });
    const query = queryParams.toString();
    const queryPrefix = query ? `?${query}` : "";
    return `${frontendUrl}${getTicketingLink(ticketingPath, isoLocale)}${queryPrefix}`;
};
export const getDonationFormMagicalLink = (frontendUrl, user, donationForm, amount) => {
    const magicalLinkPath = getFormLink(donationForm, null);
    return generateMagicalLink(frontendUrl, user, magicalLinkPath, amount);
};
